import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTemTaahhutAramaComponent} from './ctl-tem-taahhut-arama/ctl-tem-taahhut-arama.component';
import {TemTaahhutService} from './ctl-tem-taahhut.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {ControlConditionModel} from "../../../models/gen-control.model";
import {alert} from "devextreme/ui/dialog";

@Component({
  selector: 'dk-ctl-tem-taahhut',
  templateUrl: './ctl-tem-taahhut.component.html',
  styleUrls: ['./ctl-tem-taahhut.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTemTaahhutAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ],
  providers: [TemTaahhutService],
})
export class CtlTemTaahhutComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "TemTaahhut";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code: any;
  @Input() codeField: any;
  @Input() period!: number;
  @Input() kurumsalKod: string;
  @Input() kisiKod: any;
  @Input() controlCondition: ControlConditionModel[];
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TemTaahhutService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period'] || changes['kurumsalKod'] || changes['codeField'] || changes['kisiKod']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period,this.kurumsalKod,this.codeField,this.controlCondition,this.isReadOnly,this.isBindCheck)
      }
    }
        if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period,this.kurumsalKod,this.codeField,this.controlCondition,this.isReadOnly,this.isBindCheck)
          }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Tem Taahhüt)"
      this.showAction = false
    }
        this.service.setParams(this.period,this.kurumsalKod,this.codeField,this.controlCondition,this.isReadOnly,this.isBindCheck)
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        this.service.codeField=this.control.valueField
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;
        }
      });
  }


  searchClick() {
    if(this.kisiKod) {
      if (this.showAction) this.crudPopupVisible = true
      else this.toastVisible = true
    } else {
      alert("Lütfen işlem yapacağınız Cari Kişi'yi seçiniz!","Uyarı")
    }
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.kisiKod && e ) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
    } else {
      this.title = '';
      this.code = '';
      this.data = null;
      this.dataResult.emit(null);
      if(e) {
        alert("Lütfen işlem yapacağınız Cari Kişi'yi seçiniz!", "Uyarı").then(r => {
          this.title = '';
          this.code = '';
          this.data = null;
          this.dataResult.emit(null);
        })
      }
    }
  }

  getData(code: any, isSetData?: boolean) {
    this.data = this.service.getData(Number(code),this.control, this.period,this.kurumsalKod, this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].AdSoyadUnvan + ' ' + result[0].Konu;
        this.code = result[0][this.control.valueField];
        this.dataResult.emit(result[0]);
        this.isFirst = true
      } else if (this.code.length > 0) {
        this.utilsService.showError('Taahhüt Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.isFirst = true
      this.title = result.data.AdSoyadUnvan + ' ' + result.data.Konu;
      this.code = result.data[this.control.valueField];
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }

}
